/* v2 How to Apply — shared behaviour (video lazy-load, subnav smooth scroll + scrollspy).
   Safe to include from multiple sections: initialises once. */
(function () {
  if (window.__v2htaInit) return;
  window.__v2htaInit = true;

  // --- Lazy YouTube: click cover -> inject iframe ---
  document.addEventListener('click', function (e) {
    var cover = e.target.closest('.v2-hta-cover');
    if (!cover) return;
    var id = cover.getAttribute('data-video-id');
    var box = cover.closest('.v2-hta-video');
    if (!id || !box) return;
    var ratio = box.querySelector('.v2-hta-ratio') || box;
    var iframe = document.createElement('iframe');
    iframe.setAttribute('src', 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0');
    iframe.setAttribute('allow', 'autoplay; encrypted-media; fullscreen; picture-in-picture');
    iframe.setAttribute('allowfullscreen', 'true');
    iframe.setAttribute('title', 'Video');
    // remove overlay elements, keep ratio box
    cover.parentNode.removeChild(cover);
    ratio.appendChild(iframe);
  });

  // --- Smooth scroll: any in-page anchor inside the v2 HTA sections
  //     (subnav, header, announcement bar, inline links). ---
  var SCROLL_OFFSET = 90; // clears the sticky header

  function scrollToAnchor(hash) {
    if (!hash || hash === '#') return false;
    var el = null;
    try {
      el = document.getElementById(decodeURIComponent(hash.slice(1)));
    } catch (e) {
      el = document.getElementById(hash.slice(1));
    }
    if (!el) return false;
    var y = el.getBoundingClientRect().top + window.pageYOffset - SCROLL_OFFSET;
    window.scrollTo({ top: y < 0 ? 0 : y, behavior: 'smooth' });
    return true;
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('.v2-hta a[href^="#"]') : null;
    if (!a) return;
    if (a.target && a.target !== '' && a.target !== '_self') return;
    if (scrollToAnchor(a.getAttribute('href'))) e.preventDefault();
  });

  // --- Subnav: scrollspy ---
  function initNav() {
    var nav = document.querySelector('.v2-hta-subnav');
    if (!nav) return;
    var links = Array.prototype.slice.call(nav.querySelectorAll('a[href^="#"]'));
    if (!links.length) return;

    var targets = links.map(function (a) {
      var el = document.getElementById(a.getAttribute('href').slice(1));
      return el ? { link: a, el: el } : null;
    }).filter(Boolean);

    function onScroll() {
      var pos = window.pageYOffset + 140;
      var current = targets[0];
      for (var i = 0; i < targets.length; i++) {
        if (targets[i].el.offsetTop <= pos) current = targets[i];
      }
      links.forEach(function (a) { a.classList.remove('is-active'); });
      if (current) current.link.classList.add('is-active');
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNav);
  } else {
    initNav();
  }
})();
